export default __webpack_public_path__ + "static/media/illus-choose-label.42869e38.svg";